module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/pricing-booking/transport-management/transport-management.component.css
// module id = ./src/app/component/pricing-booking/transport-management/transport-management.component.css
// module chunks = main